export default __webpack_public_path__ + "static/media/ImageIcon.8bbd8b1f.svg";